<template>
    <div class="grade grade-student assessment">
        <h1>Оценка знаний</h1>

        <v-tabs class="mt-8" v-model="tab" align-with-title color="#4854FE">
            <v-tab class="ml-0" v-for="item in items" :key="'j'+item.id" @click="tabClick(item)">
                {{ item.name }}
            </v-tab>
        </v-tabs>

        <div class="grade_container">
            <div class="grade-bar-container assessment-bar">
                <SingleRating ref="singleRating" :loading="loading" />
                <RatingTabs ref="ratingTabs" :loading="loading" />
            </div>
            <Filters :full="false" @update="loadReport" />
            <div class="grade-bar-container">
                <ResultsByMonth ref="resultsByMonth" :loading="loading" />
                <ResultsBySubject ref="resultsBySubject" :loading="loading" />
            </div>
            <ResultsTable ref="resultsTable" :full="false" :loading="loading" />
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import SingleRating from './SingleRating/index.vue';
import RatingTabs from './RatingTabs/index.vue';
import Filters from '../../Shared/Grade/Filters/index.vue';
import ResultsByMonth from '../../Shared/Grade/ResultsByMonth/index.vue';
import ResultsBySubject from '../../Shared/Grade/ResultsBySubject/index.vue';
import ResultsTable from '../../Shared/Grade/ResultsTable/index.vue';
import '../../Shared/Grade/index.scss';
import './index.scss';

export default {
    name: 'Assessment',
    components: {
        SingleRating,
        RatingTabs,
        Filters,
        ResultsByMonth,
        ResultsBySubject,
        ResultsTable
    },
    computed: {
        ...mapGetters({
            apiUrl: 'apiUrl',
            userInfo: "user/userInfo",
            getPageSize: "tests/getPageSize"
        })
    },
    data() {
        return {
            filters: [],
            tab: 0,
            items: [{id: 0, name: 'Актуальные'}, {id: 1, name: 'Архивные'}],
            loading: false
        }
    },
    methods: {
        ...mapActions({
			getUserInfo: "user/getUserInfo",

		}),
        tabClick(item) {
            this.$root.$emit('resetFilters');

            this.loadReport([], item.id);
        },
        loadReport(filters, archive) {
            this.loading = true;
            this.filters = filters;
            let fromArchive = archive === 1 ? true : false;

            this.$http.post(`${this.apiUrl}TestTask/GetResultsReport?fromArchive=${fromArchive}`, {
                    filters: filters,
                    pageSize: this.getPageSize
                })
                .then((result) => {
                    this.$refs.resultsTable.update(result.data, filters, fromArchive);

                    let report = result.data.data[0];

                    if (this.userInfo === null) {
                        this.getUserInfo().then(() =>
                            this.updateRating(report)
                        );
                    } else {
                        this.updateRating(report);
                    }

                    this.$refs.resultsByMonth.update(report.resultsByMonth);
                    this.$refs.resultsBySubject.update(report.resultsBySubject);

                    this.loading = false;
            });
        },
        updateRating(report) {
            this.$refs.singleRating.update(report.studentsRating);
            this.$refs.ratingTabs.update(report.studentsRating);
        },
        getRatingByGroup(rating) {
            let byGroup = [];

            console.log('this.userInfo', this.userInfo);

            if(this.userInfo && this.userInfo.studyGroupIds && this.userInfo.studyGroupIds.length > 0) {
                rating.forEach(x => {
                    let students = x.students.filter(y => this.userInfo.studyGroupIds.includes(y.studyGroupId));
    
                    if (students.length > 0) {
                        let place = {
                            score: x.score,
                            students: students
                        };
    
                        byGroup.push(place);
                    }
                });
            }

            return byGroup;
        }
    },
    mounted() {
        this.loadReport([], this.tab);
    }
}
</script>
